// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__Nihlo","title":"ClientReferral_title__3gPhD","itemText":"ClientReferral_itemText__2DfRl"};